import api from 'Application/api/api';

const getCurrentUser = (cancelToken = null) =>
    api.get('/user/current', {
        cancelToken,
    });

export default getCurrentUser;
